import { toCrLf } from "./lineBreaks";

// How the backend counts a text field. A value sent as multipart form data reaches it with every line break as \r\n
// (every browser converts them), so a line break is two characters there; a JSON value keeps \n, one character.
export type LineBreakCount = "lf" | "crlf";

export const countText = (value: string | undefined | null, lineBreaks: LineBreakCount = "lf"): number => {
	if (!value) {
		return 0;
	}
	return (lineBreaks === "crlf" ? toCrLf(value) : value).length;
};

// The longest start of the value that still fits the limit, cut at whole characters (an emoji is never split).
export const cutTextToLimit = (value: string, max: number, lineBreaks: LineBreakCount = "lf"): string => {
	if (countText(value, lineBreaks) <= max) {
		return value;
	}

	let length = 0;
	let end = 0;
	let previous = "";
	for (const character of value) {
		// A lone \n becomes \r\n on a multipart request; the \n of an \r\n pair adds only itself.
		const added = lineBreaks === "crlf" && character === "\n" && previous !== "\r" ? 2 : character.length;
		if (length + added > max) {
			break;
		}
		length += added;
		end += character.length;
		previous = character;
	}
	return value.slice(0, end);
};
